import {GetStepParams} from './types';

const getExamStepPosition = ({isManualLocation}: GetStepParams) => {
	const LOCATION_STEP = 0;
	const SPECIALITY_OR_EXAM_STEP = 1;
	const DISTRICT_STEP = 2;
	const UNIT_STEP = isManualLocation ? 3 : 2;
	const PROFESSIONAL_STEP = isManualLocation ? 4 : 3;
	const REVIEW_STEP = isManualLocation ? 5 : 4;

	return {
		LOCATION_STEP,
		SPECIALITY_OR_EXAM_STEP,
		DISTRICT_STEP,
		UNIT_STEP,
		PROFESSIONAL_STEP,
		REVIEW_STEP,
	};
};

export {getExamStepPosition};
